<template>
  <div
    id="ServiceNotFound"
    class="d-flex flex-column align-items-center justify-content-center p-5"
  >
    <p class="message-paragraph brand-highlight-3 mb-5">
      Sorry, the service you're looking for doesn't exist.
    </p>
    <b-button variant="cta" size="lg" @click="goHome">Go to Home</b-button>
  </div>
</template>

<script>
export default {
  name: "ServiceNotFound",
  methods: {
    goHome() {
      this.$router.push("/");
    }
  }
};
</script>

<style lang="less">
#ServiceNotFound {
  .message-paragraph {
    font-size: 1.6rem;
    text-align: center;
    margin: 0 auto;
  }
}
</style>
